import { render, staticRenderFns } from "./CustomsDashboard.vue?vue&type=template&id=0b88ebc3&scoped=true&"
import script from "./CustomsDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CustomsDashboard.vue?vue&type=style&index=0&id=0b88ebc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88ebc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b88ebc3')) {
      api.createRecord('0b88ebc3', component.options)
    } else {
      api.reload('0b88ebc3', component.options)
    }
    module.hot.accept("./CustomsDashboard.vue?vue&type=template&id=0b88ebc3&scoped=true&", function () {
      api.rerender('0b88ebc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/CustomsDashboard.vue"
export default component.exports